// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    website_traffic_summary: 'Leyendo las cifras de la web',
    website_find_leads: 'Buscando entre los contactos de la web',
    website_lead_detail: 'Abriendo el contacto',
  },
  ca: {
    website_traffic_summary: 'Llegint les xifres del web',
    website_find_leads: 'Cercant entre els contactes del web',
    website_lead_detail: 'Obrint el contacte',
  },
  en: {
    website_traffic_summary: 'Reading the website figures',
    website_find_leads: 'Looking through the leads',
    website_lead_detail: 'Opening the lead',
  },
  fr: {
    website_traffic_summary: 'Lecture des chiffres du site',
    website_find_leads: 'Recherche parmi les prospects',
    website_lead_detail: 'Ouverture du prospect',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
